import styled from 'styled-components';

const AboutAnimCharsStyle = styled.div`
	&.AboutAnim {
		background-color: var(--color1);
		width: 300px;

		svg {
			mix-blend-mode: difference;
			width: 100%;
			height: auto !important;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			margin-top: -50%;
		}
	}
`;

export default AboutAnimCharsStyle;
